import type { GAEventSchema } from './types';

const isWindowDataLayer = (
  dataLayer: (typeof window)['dataLayer'],
): dataLayer is GAEventSchema[] => {
  if (!window.dataLayer) {
    return false;
  }

  return true;
};

/* TODO: Replace this with function imported from client-utils
This is a copy of the function in client-utils. 
 */
export const linkClickOpensInNewTab = (
  evt: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent,
  eventTarget?: HTMLAnchorElement,
) => {
  const target = (eventTarget || evt.currentTarget).getAttribute('target') || '_self';
  const modifier = [evt.shiftKey, evt.ctrlKey, evt.metaKey].some((k) => k === true);

  return target !== '_self' || modifier;
};

export const hasMatchingDataLayerEvent = <T extends GAEventSchema>(event: T) => {
  if (!isWindowDataLayer(window.dataLayer)) {
    return false;
  }

  const hasMatchingEvent = (dataLayerEvent: GAEventSchema) =>
    Object.entries(event).every(
      ([key, value]) => dataLayerEvent[key as keyof GAEventSchema] === value,
    );

  return window.dataLayer.some(hasMatchingEvent);
};
